var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3238 14.8261L17.1582 22.9916C16.9307 23.2191 16.632 23.3334 16.3334 23.3334C16.0347 23.3334 15.736 23.2191 15.5085 22.9916C15.0523 22.5354 15.0523 21.798 15.5085 21.3418L21.6836 15.1667H3.50004C2.85487 15.1667 2.33337 14.644 2.33337 14C2.33337 13.356 2.85487 12.8334 3.50004 12.8334H21.6836L15.5085 6.65825C15.0523 6.20208 15.0523 5.46467 15.5085 5.00851C15.9647 4.55234 16.7021 4.55234 17.1582 5.00851L25.3238 13.174C25.4323 13.2825 25.5175 13.4108 25.577 13.5543C25.6948 13.839 25.6948 14.1611 25.577 14.4458C25.5175 14.5893 25.4323 14.7176 25.3238 14.8261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.00c80b2db9af9878fe83b5082d481871.svg";
export { ForwardRef as ReactComponent };